import { render, staticRenderFns } from "./App.vue?vue&type=template&id=400a9b66&%3Astyle=%5B%0A%20%20%7B%20backgroundImage%3A%20'url(http%3A%2F%2Falpha.gixcore.com%2Fimg%2Fsep09.jpg)'%20%7D%5D&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports